import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
import { NetGet } from '../../axios'
import { homeBigText } from '../../resource'
import coverinit from './hometool/coverimg'
import './homeTop.css'
// 引入action
// import { ReactSVG } from 'react-svg'

class HomeTop extends Component {
    constructor() {
        super()
    }
    onClick() {
        console.log(document.querySelector(".article-index"))
        var { clientHeight } = document.documentElement
        try {
            window.scrollTo(
                0,
                clientHeight - (clientHeight * 3 / 100)
            );
            // window.scrollTo({
            //     left: 0,
            //     top: clientHeight-(clientHeight*3/100),
            //     behavior: 'smooth',
            //   });
        } catch (error) {
            console.log(error)
        }

        // document.documentElement.scrollTop=document.documentElement.clientHeight
    }
    componentDidMount() {
        this.left1 = -236
        this.left2 = 0

        var fun = () => {
            this.loadcoverimg().then(() => {
                this.runtime = setTimeout(() => {
                    fun()
                }, 8000);
            })
        }
        fun()



        this.waveloop1()
        this.waveloop2()
    }
    componentWillUnmount() {
        this.runtime && clearTimeout(this.runtime)
    }

    loadcoverimg = async () => {
        this.covermodal.classList.remove("covermodalload")
        // this.covermodal.classList.add("covermodalloaded")
        NetGet('coverimg')
            .then((res) => {
                var coverimg = res

                var coverimgDom = document.getElementById('coverimg')
                coverimgDom.style.backgroundImage = `url(${coverimg.host + coverimg.links[0]})`
                var imgUrl = coverimg.host + coverimg.links[1]
                var bg = `url(${imgUrl})`
                // this.covermodal.style.backgroundColor="rgba(0,0,0,1)"
                // this.covermodal.classList.remove("covermodalloaded")

                this.covermodal.classList.add("covermodalload")

                var imgObject = new Image();
                imgObject.src = imgUrl;

                imgObject.onload = () => {
                    coverimgDom && (coverimgDom.style.backgroundImage = bg)
                    // this.img.setAttribute('class', 'thumbnails complete');
                }
                imgObject.onerror = () => {
                    coverimgDom && (coverimgDom.style.backgroundImage = 'https://cdn.jsdelivr.net/gh/A-ANing/manifest_s@master/myblog/images/onerr/98fca04416944b282a558b98b2131879.png')
                }
            })
    }


    waveloop1 = () => {
        var dom1 = document.getElementById("banner_wave_1")
        if (!dom1) { return false }
        if (this.left1 <= -1233) {
            this.left1 = -236
        }
        dom1.style.left = "" + this.left1-- + "px"
        requestAnimationFrame(() => this.waveloop1())
    }
    waveloop2 = () => {
        var dom2 = document.getElementById("banner_wave_2")
        if (!dom2) { return false }
        if (this.left2 <= -1009) {
            this.left2 = 0
        }
        this.left2 -= 0.5
        dom2.style.left = "" + this.left2 + "px"
        requestAnimationFrame(() => this.waveloop2())
    }
    videoBtn = () => {
        this.runtime && clearTimeout(this.runtime)
        const classlist = Array.from(this.videobtn.classList)
        if (classlist.indexOf('video-pause') >= 0) {
            this.videobtn.classList.remove("video-pause")
            this.video.pause()
            this.videostu.innerHTML = "已暂停 ..."
            this.videostu.style.bottom = "0px"
            this.myinfo.style.top = "49.3%"
        } else {
            this.videobtn.classList.add("video-pause")
            if (!this.isplay) {
                this.video.src = "https://cdn.jsdelivr.net/gh/moezx/cdn@3.1.3//The Pet Girl of Sakurasou.mp4"
                this._readyVideo();
                this.videostu.style.bottom = "0"
                this.videostu.innerHTML = "正在载入视频 ..."
            }

            this.video.play()
            this.isplay = true
        }

    }

    _readyVideo = () => {
        const { video } = this
        video.addEventListener('canplay', () => {
            this.videostu.style.bottom = "-100px"
        }, false);
        video.addEventListener('play', () => {
            this.myinfo.style.top = "-999px"
            this.videostu.style.bottom = "-100px"
        }, false);
        // video.addEventListener('pause', () => {
        //     this.videostu.innerHTML = "已暂停 ..."
        //     this.videostu.style.bottom = "0px"
        // }, false);
        video.addEventListener('error', () => {
            this.videostu.innerHTML = '请求数据时遇到错误'
            this.videostu.style.bottom = "0px"
            this.myinfo.style.top = "49.3%"
        }, false);
    }

    videoload = () => {
        //this.videostu.style.bottom="-100px"
    }
    render() {
        return (
            <>
                <div className="allMargintop" style={styles.fabox}>
                    <div className="tipimgBox">


                        <div style={styles.bgimg} id='coverimg'>

                            <div className="tiptop-inner" ref={(e) => this.myinfo = e}>
                                <h1><a href="/" data-text="Hi, Cat Ning!">Hi, Cat Ning!</a></h1>
                                <div className="header-info">
                                    <p>
                                        <i className="fa fa-quote-left"></i>
                                        You got to put the past behind you before you can move on.
                                <i className="fa fa-quote-right"></i>
                                    </p>
                                    <div className="top-social_v2">
                                        <li id="bg-pre">
                                            <img className="flipx" src="http://ningcat.com/siteasset/next-b.svg" />
                                        </li>
                                        <li>
                                            <a href="https://github.com/A-ANing" target="_blank" className="social-github" title="github">
                                                <img src="http://ningcat.com/siteasset/github.png" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.jianshu.com/u/e974af4433d8" target="_blank" className="social-jiasnu" title="简书">
                                                <img src="http://ningcat.com/siteasset/jianshu.png" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://t.me" target="_blank" className="social-lofter" title="telegram">
                                                <img src="http://ningcat.com/siteasset/telegram.svg" />
                                            </a>
                                        </li>
                                        <li id="bg-next"><img src="http://ningcat.com/siteasset/next-b.svg" /></li>
                                    </div></div>
                            </div>
                            <div className="covermodal" ref={e => this.covermodal = e} />

                        </div>
                        {/* <div style={styles.overlay} ></div> */}
                    </div>


                    {/* <div id="banner_wave_1">
                    </div>

                    <div id="banner_wave_2">
                    </div> */}

                    <div id="video-container">
                        <video id="bgvideo" class="video" ref={(e) => this.video = e} muted src="" width="auto" autoPlay="false" style={{ minHeight: "969px" }}></video>
                        <div id="video-btn" class="loadvideo videolive" ref={(ref) => this.videobtn = ref} onClick={this.videoBtn}></div>
                        <div id="video-add"></div>
                        <div class="video-stu" ref={(e) => this.videostu = e}></div>
                    </div>


                    <div class="headertop-down faa-float animated" onClick={this.onClick}>
                        <span>
                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                        </span>
                    </div>

                    {/* 
                    <div className="tiptop-learn-more">
                        <a className="anchor" onClick={this.onClick} ><i className="fe fe-mouse"></i></a>
                    </div> */}


                    {/* <ReactSVG style={{width:"500px"}} src={"svgCat.svg"} frameborder="0" col = "10" row = "10"></ReactSVG>\ */}
                    {/* <iframe src={'cat.html'} title="1"  frameBorder="0" col = "10" row = "10" width="800" height="500"></iframe> */}
                </div>

            </>
        )
    }
}



const styles = {
    bgimg: {
        width: "100%",
        height: "100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPositionX: "center"
    },

    overlay: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "rgba(178,191,204,0.6)"
    },
    yun: {
        position: "absolute",
        zIndex: "1",
        right: "0",
        bottom: "-1px",
        left: "0",
        minWidth: "100%"
    },
    fabox: {
        // display: "-webkit-box",
        // display: "-ms-flexbox",
        // 

        position: "relative",

        marginBottom: 0,
        overflow: 'hidden',
        backgroundColor: "#f8f8f8",
        height: "auto"

    },
    inline_block: {
        display: "inline-block"
    },
    name: {

    },
    a: {
        cursor: "pointer",
        padding: "0 2.5rem",
        color: "inherit",
        textDecoration: "none",
        fontWeight: "500",
        lineHeight: "80px",
    }
}




export default connect()(HomeTop)